import { ContentHeader } from '@features/ui/components';
import { useTranslation } from 'next-i18next';

export const ResourcesContentHeader = (): JSX.Element => {
  const { t } = useTranslation('common');
  return (
    <ContentHeader
      title={t('pages.resources.contentHeader.title')}
      upperTitle={t('pages.resources.contentHeader.upperTitle')}
    />
  );
};
